const FILE_NAME_REGEX = /.*filename=['"]?([^"]+)/;
const ENCODED_FILE_NAME_REGEX = /.*filename\*=utf-8''([^;]+)/i;
const BASE64_REGEX = /(\?utf-8\?b\?)([a-z0-9+/]*)(?==?=?\?)/i;

export function getFileNameFromContentDisposition(contentDisposition: string): string {
  const fileName = contentDisposition.match(FILE_NAME_REGEX);
  const encodedFileName = contentDisposition.match(ENCODED_FILE_NAME_REGEX);

  if (encodedFileName) {
    return decodeURIComponent(encodedFileName[1]);
  }

  if (!fileName) {
    throw new Error('File name not found in content disposition');
  }

  const base64FileName = fileName[1].match(BASE64_REGEX);

  if (base64FileName) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    return getDecodedBase64(base64FileName[2]);
  }

  return fileName[1];
}

// Function to decode Base64 string that could contain Unicode characters
function getDecodedBase64(str: string): string {
  return decodeURIComponent(
    atob(str)
      .split('')
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      .map((character) => ['%', `00${character.charCodeAt(0).toString(16)}`.slice(-2)].join(''))
      .join(''),
  );
}
